<!-- template v.1 -->
<template>
<div class="col py-3">
            <div class="col-md-12" style="padding:0; text-align:center;margin-bottom:15px">
              <h4 class="card-title" style="text-decoration:underline">Marcación del empleado </h4>
              <span style="font-size: 20px;">{{Nombres}}</span>
            </div>
             <div class="col-md-12" style="padding:0">
            <!-- Profile Image -->
            <div class="card card-info">
              <div class="card-header">
                <h3 class="card-title">Filtros</h3>
                
              </div>
              <div class="card-body" style="padding-top:0px">
              <div class="col-md-12">
                  
                  <div class="col-md-4 form-org">
                       <div class="form-group">
                  <label class="col-form-label" >
                    Desde</label
                  >
                   <input type="date" class="form-control" min="1900-01-01"  v-model="FechaRegistroInicio" v-bind:max="Fechainiciomax" @change="FechafinUpdate()" >
                </div>
                   <div class="form-group ">
                  <label class="col-form-label" >
                    Marcaciones</label
                  >
                  <select class="form-control"    v-model="Marcacion">
                    <option value="-1" >Todos </option>
                    <option v-for="item in Marcaciones" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                    
                  </select>
                </div>
                  </div>
                
              </div>
              <div class="col-md-4 form-org">
                    

                <div class="form-group">
                  <label class="col-form-label" >
                    Hasta</label
                  >
                  <input type="date" class="form-control" max="2099-12-12" v-bind:min="Fechafinmin" @change="FechainicioUpdate()" v-model="FechaRegistroFin">
                </div>
                <div class="input-group" style="margin-top:38px">
                   <button type="submit" 
                   class="btn btn-success" 
                   style="width:100%" 
                   @click="Buscar()" >
                   
                   Buscar</button>
                </div>
              </div>
             
               
               
               
           
              </div>
              <!-- /.card-body -->
            </div>
           
          

      </div>
      <div class="col-md-12" style=" margin-top: 15px; float:left;padding:0;">
          
          
           <table class="table table-hover table-responsive"  >
                  <thead  class="tabla-asistencia">       
                    <tr >
                      <th >Día</th>
                      <th >Fecha</th>
                      <th >Hora</th>
                      <th >Observación</th>
                      <th >Comentario</th>
                      <th >Opciones</th>
                      <th >Estado</th>

                   
                     
                    </tr>
                  </thead>
                  
                   <tbody v-for="(item, index) in MarcacionesPaginador"   v-bind:key="item" v-bind:index="index" >
                    <tr >
              <!--  <tbody v-for="(item, index) in ListaMarcaciones.filter(Paginador)"   v-bind:key="item" v-bind:index="index" v-show="(pag - 1) * NUM_RESULTS <= index  && pag * NUM_RESULTS > index">
                    <tr v-if="!item.disabled"> -->
                      <td >{{item.sDiaDesc}}</td>
                      <td >{{item.sFecha}}</td>
                      <td ><span v-if="item.sHora != '00:00'">{{item.sHora}}</span>
                          <span v-else style="color:red">{{item.sHora}}</span>
                      </td>
                      <td >{{item.sObservacion}}</td>
                      <td >{{item.sComentario}}</td>
                      <td style="width: 50%;">
                        <button type="button" class="btn btn-info btn-table" @click="Editar(item)">Editar</button>
                        <button type="button" class="btn btn-info btn-table" @click="Borrar(item)">Borrar</button>
                        <button type="button" class="btn btn-info btn-table" @click="Historial(item)">Ver</button>
                        <button type="button" class="btn btn-info btn-table" @click="Horario(item)">Horario</button>
                        <button type="button" class="btn btn-info btn-table" @click="Obs(item)">Obs</button>
                      </td>
                      <td >
                        <p v-if="item.nEstado == 1" class="estado-verde" ></p>
                        <p v-else-if="item.nEstado == 2" class="estado-rojo" ></p>
                        <p v-else ></p>
                      
                      </td>

                    
                      
                    </tr>

                    
                  </tbody>
                 
                   
         
                </table>
                <div style="display: flex;align-items: start;  " >
                    <button  @click="setPage(1)" type="button" style="border-radius: 0px;" class="btn btn-primary" >Primero</button>
                    <nav aria-label="Page navigation example" style="    background: transparent !important;">
                      <ul class="pagination">
                        <li class="page-item" v-for="(pageNumber, index) in totalPages" :key="index" v-show="Math.abs(pageNumber - currentPage) <= 5  || pageNumber == totalPages || pageNumber == 0" >
                            <a class="page-link" style="cursor:pointer" @click="setPage(pageNumber)" :class="{current: currentPage === pageNumber, last: (pageNumber == totalPages && Math.abs(pageNumber - currentPage) > 3), first:(pageNumber == 0 && Math.abs(pageNumber - currentPage) > 3)}">
                                {{ pageNumber }} 
                            </a>
                        </li>
                    </ul>
                    </nav>
                </div>
              <!--  <nav aria-label="Page navigation" class="text-center;">
                  <ul class="pagination pagination-sm " style="margin-bottom: 0px;float:right">
                    <li class="page-item">
                      <a href="#" aria-label="Previous" class="page-link" v-show="pag != 1" @click.prevent="pag -= 1">
                        <span aria-hidden="true">Anterior</span>
                      </a>
                    </li>
                    <li class="page-item" style="margin-right:0">
                      <a href="#" aria-label="Next" class="page-link" v-show="pag * NUM_RESULTS / ListaMarcaciones.filter(Paginador).length < 1" @click.prevent="pag += 1">
                        <span aria-hidden="true">Siguiente</span>
                      </a>
                    </li>
                  </ul>
                </nav> -->
        </div>
</div>
<ModalPeque v-show="ModalPeque.isEditarMarcaciones" :modalpeque="ModalPeque">  
    <div class="col-md-12 form-org">
        <div class="form-group">
            <label class="col-form-label"> Fecha </label>
                <input type="date" min="1990-01-01" max="2999-12-31" v-model="FechaMarcacion" class="form-control"  >
        </div>
        <div class="form-group">
            <label class="col-form-label"> Hora </label>
                <input type="time" v-model="HoraMarcacion" class="form-control"  >
        </div>
        <div class="form-group">
            <label class="col-form-label"> Comentario </label>
                <textarea type="text" maxlength="200" v-model="ComentarioMarcacion" class="form-control"  ></textarea>
        </div>
        <div class="modal-footer botones-modal">
        <button type="button" class="btn btn-success guardar-modal" @click="EditarMarcacion()" >Guardar</button>
        <button type="button" class="btn btn-danger cancelar-modal" @click="ModalPeque.isEditarMarcaciones = false"> Cancelar</button>
      </div>
    </div>
    
</ModalPeque> 

<ModalPeque v-show="ModalPeque.isObservacion" :modalpeque="ModalPeque">  
    <div class="col-md-12 form-org">
        <div class="form-group">
            <label class="col-form-label"> Observación </label>
                <textarea type="text" maxlength="200" v-model="obsMarcacion" class="form-control"  ></textarea>
        </div>
        <div class="modal-footer botones-modal">
        <button type="button" class="btn btn-success guardar-modal" @click="EditarObservacion()" >Guardar</button>
        <button type="button" class="btn btn-danger cancelar-modal" @click="ModalPeque.isObservacion = false"> Cancelar</button>
      </div>
    </div>
    
</ModalPeque>
<ModalPeque v-show="ModalPeque.isEliminarMarcaciones" :modalpeque="ModalPeque">  
    <div class="col-md-12 form-org">
        <div class="form-group">
            <label class="col-form-label"> ¿Está seguro de eliminar la marcación? </label>
        </div>
        
        <div class="modal-footer botones-modal">
        <button type="button" class="btn btn-success guardar-modal" @click="EliminarMarcacion()" >Aceptar</button>
        <button type="button" class="btn btn-danger cancelar-modal" @click="ModalPeque.isEliminarMarcaciones = false"> Cancelar</button>
      </div>
    </div>
   
</ModalPeque>  
<ModalGrande v-show="ModalGrande.isHistorialMarcaciones" :modalgrande="ModalGrande">  
    <div class="col-md-12 form-org">
        
        
         <table class="table table-hover table-responsive"  >
                  <thead  class="tabla-asistencia">       
                    <tr >
                      <th >Fecha</th>
                      <th >Hora</th>
                      <th >Observación</th>
                      <th >Comentario</th>
                      <th >Fecha Registro</th>
                      <th >Usuario</th>

                   
                     
                    </tr>
                  </thead>
                  
                   <tbody v-for="(item, index) in HistorialMarcaciones"   v-bind:key="item" v-bind:index="index" >
                    <tr >
                   
                      <td >{{item.sFecha}}</td>
                      <td >{{item.sHora}}</td>
                      <td >{{item.sObservacion}}</td>
                      <td >{{item.sComentario}}</td>
                       <td >{{item.sFechaRegistro}}</td>
                      <td >{{item.sUsuario}}</td>
                      

                    
                      
                    </tr>

                    
                  </tbody>
                 
                   
         
                </table>
               
        </div>
</ModalGrande> 
<ModalMediano v-show="ModalMediano.isHorarioMarcaciones" :modalmediano="ModalMediano">  
      
        <div class="col-md-12">

          <div class="col-md-6 form-org">
            <div class="form-group">
              <label class="col-form-label"> Nuevo Horario </label>
                <select class="form-control"    v-model="NuevoHorario" >
                  <option value="-1" >Seleccionar Horario </option>
                  <option v-for="item in Horarios" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                </select>
            </div>
                   
          </div>
          <div class="col-md-6 form-org">
            <div class="form-group" style="float: left">
                <label class="col-form-label w-100">Fecha y Hora Vigencia</label>
                    <input type="date" min="1990-01-01" max="2999-12-31" v-model="NuevaFecha" class="form-control" style="width: 53%;float: left;" disabled>
                    <input type="time" v-model="NuevaHora" class="form-control" style="    width: 40%; float: right; text-align: center;" disabled > 
            </div>
      
          </div>
        </div>

        <div class="col-md-12">


            <div class="col-md-6 form-org">
              <div class="form-group">
                  <label class="col-form-label"> Comentario </label>
                      <textarea type="text" maxlength="200" v-model="ComentarioHorario" class="form-control"  ></textarea>
              </div> 
              
            </div>
            <div class="col-md-6 form-org">
              <div class="input-group" style="margin-top: 38px; float: left;">
                  <button type="submit" 
                    class="btn btn-success" 
                    style="width: 100%;" 
                    @click="Asignar()" 
                  >
                  
                  Asignar
                  </button>
              </div>

            </div>

        </div>

        <div class="col-md-12" style="float: left;">
          <table class="table table-hover table-responsive" style="margin-top: 15px;float: left;"  >
            <thead  class="tabla-asistencia">       
              <tr >
              
                <th >Horario</th>
                <th >Vigencia Inicio</th>
                <th >Comentario</th>
                <th >Estado</th>
              </tr>
            </thead>
            
            <tbody v-for="(item, index) in ListaHorariosPaginador"   v-bind:key="item" v-bind:index="index"  >
              <tr>
                <td >{{item.sNombre}}</td>
                
                <td >{{item.sVigencia}}</td>
                <td >{{item.sComentario}}</td>
                <td >{{item.sEstado}}</td>
              </tr>

            </tbody>
            
              
    
          </table>
          <div style="display: flex;align-items: start;float:left  " >
              <button  @click="setPageHorario(1)" type="button" style="border-radius: 0px;" class="btn btn-primary" >Primero</button>
              <nav aria-label="Page navigation example" style="    background: transparent !important;">
                <ul class="pagination">
                  <li class="page-item" v-for="(pageNumberHorario, index) in totalPagesHorario" :key="index" v-show="Math.abs(pageNumberHorario - currentPageHorario) <= 5  || pageNumberHorario == totalPagesHorario || pageNumberHorario == 0" >
                      <a class="page-link" style="cursor:pointer" @click="setPageHorario(pageNumberHorario)" :class="{current: currentPageHorario === pageNumberHorario, last: (pageNumberHorario == totalPagesHorario && Math.abs(pageNumberHorario - currentPageHorario) > 3), first:(pageNumberHorario == 0 && Math.abs(pageNumberHorario - currentPageHorario) > 3)}">
                          {{ pageNumberHorario }} 
                      </a>
                  </li>
                </ul>
              </nav>
          </div>
        </div>  
        
</ModalMediano> 
<div class="overlay-wrapper"  v-if="load">
        <div class="overlay" style="flex-direction: column;">
            <i class="spinner-border"></i>
            <div class="text-bold pt-2">Cargando...</div>
        </div>
    </div>
</template>
<script>
export default {
     props: ["content"],

  data: function () {
    return {
      Marcaciones:[],
      Marcacion:-1,
      Fechafinmin : '1900-01-01',
      Fechainiciomax : '2099-12-12',
      FechaRegistroInicio : '',
      FechaRegistroFin : '',
      FechaMarcacion:'',
      HoraMarcacion: '',
      FechaActual:'',
      HoraActual: '',
      ComentarioMarcacion: '',
      CodigoMarcacion:'',
      NuevaFecha:'',
      NuevaHora:'',
      observacion: '',
      NuevoHorario:-1,
      Horarios:[],
      ListaMarcaciones:[],
      MarcacionesPaginador:[],
      ListaHorariosPaginador:[],
      ListaHorarios:[],
      HistorialMarcaciones:[],
      Empleado:this.$route.query.id,
      Nombres:this.$route.query.nombre,
      ComentarioHorario:"",
      load:false,
      itemsPageDefault : 30,
      resultCount: 0,
      currentPage: 0,
      itemsPageDefaultHorario : 4,
      resultCountHorario: 0,
      currentPageHorario: 0,

      ModalPeque : {
        isEditarMarcaciones : false,
        isEliminarMarcaciones : false,
        isObservacion: false,
      },
      ModalGrande : {
        isHistorialMarcaciones : false,
      },
      ModalMediano : {
        isHorarioMarcaciones : false,
      },
      obsMarcacion: '',
      obsFechaMarcacion: '',
      obsCodMarcacion: '',
      obsTipo: ''

      
    };
  },
  computed: {
        totalPages: function() {
          return Math.ceil(this.resultCount / this.itemsPageDefault)
        },
        totalPagesHorario: function() {
          return Math.ceil(this.resultCountHorario / this.itemsPageDefaultHorario)
        }
  },
  mounted(){
    this.content.login = false;
    this.content.sistema = true;

    let gestion = this.$store.state.menu;
    this.axios
        .get(gestion + "/ListarParametrosHijos?nCodigo=7", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Marcaciones = response.data.oListaParametros;
        })
    
    
    
  },
  methods: {
    Asignar(){
    if(this.NuevoHorario == -1){
    this.$swal({
          toast: true,
          timer:3000,
          position: 'top',
          showConfirmButton: false,
          title: 'Debe seleccionar un horario',
          icon: 'error',
          
          }); 
    return;
    }
    this.load=true;
    let gestion = this.$store.state.menu;
    var bodyFormData = new FormData();
    bodyFormData.append("nIdHorario", this.NuevoHorario);
    bodyFormData.append("sHora", this.NuevaHora);
    bodyFormData.append("sFecha", this.NuevaFecha);
    bodyFormData.append("nIdEmpleado", this.Empleado);
    bodyFormData.append("sComentario", this.ComentarioHorario);
    this.axios.post(gestion + "/HorarioAsignar1x1", bodyFormData, {
        headers: {
          Authorization: "Bearer " + localStorage.token,
          "Content-Type": "multipart/form-data",
        }
        })
        .then((response) => {
        const data_res = response.data.satisfactorio;
        this.load=false;
        if (data_res == true) { 
        this.axios
        .get(gestion + "/HorarioPorEmpGrilla?nIdEmpleado="+ this.Empleado, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.ListaHorarios = response.data.oListaHorariosPorEmpleado;
          this.NuevoHorario=-1;
          this.ComentarioHorario="";
          const countUser = this.ListaHorarios.filter(resp => !resp.disabled);
          this.resultCountHorario = countUser.length;
          this.currentPageHorario = 0;
          if (this.currentPageHorario >= this.totalPagesHorario) {
              this.currentPageHorario = this.totalPagesHorario
            }
          var index = this.currentPageHorario * this.itemsPageDefaultHorario;      
          this.ListaHorariosPaginador = this.ListaHorarios.slice(index,index+this.itemsPageDefaultHorario);
        })
        
        this.$swal({
          toast: true,
          timer:3000,
          position: 'top',
          showConfirmButton: false,
          title: response.data.message,
          icon: 'success',
          
          });
        }
        else {
        this.$swal({
          toast: true,
          timer:3000,
          position: 'top',
          showConfirmButton: false,
          title: response.data.message,
          icon: 'error',
          
          });  
        }
         
      });
    },
    setPage: function(pageNumber) {
            this.currentPage = pageNumber;
 
        
            if (this.currentPage >= this.totalPages) {
                this.currentPage = this.totalPages
                
            }
            var index = (this.currentPage - 1) * this.itemsPageDefault;
            this.MarcacionesPaginador = this.ListaMarcaciones.filter(resp => !resp.disabled ).slice(index, index + this.itemsPageDefault);
    },
    setPageHorario: function(pageNumberHorario) {
            this.currentPageHorario = pageNumberHorario;
 
        
            if (this.currentPageHorario >= this.totalPagesHorario) {
                this.currentPageHorario = this.totalPagesHorario
                
            }
            var index = (this.currentPageHorario - 1) * this.itemsPageDefaultHorario;
            this.ListaHorariosPaginador = this.ListaHorarios.filter(resp => !resp.disabled ).slice(index, index + this.itemsPageDefaultHorario);
    },
    Editar(item){
    this.ModalPeque.isEditarMarcaciones=true;
    this.ModalPeque.titulo = 'Edición de Marcación';
    this.HoraMarcacion = item.sHora;
    this.HoraActual = this.HoraMarcacion;
    this.CodigoMarcacion = item.nCodigo;
    this.ComentarioMarcacion = item.sComentario;
    const fecha = item.sFecha.split('/')
    this.FechaMarcacion = fecha[2]+"-"+fecha[1]+"-"+fecha[0];
    this.FechaActual = this.FechaMarcacion;
    },
    Obs(item){
      //console.log(item);
      let gestion = this.$store.state.menu;

      this.ModalPeque.isObservacion=true;
      this.ModalPeque.titulo = 'Observación de Marcación';

      this.CodigoMarcacion = item.nCodigo;
      this.obsFechaMarcacion = item.sFecha;
      this.obsTipo = item.nTipo;


      this.axios
        .get(gestion + "/ObservacionMarcVer?nIdMarcacion="+this.CodigoMarcacion+"&sFecha="+this.obsFechaMarcacion+
        "&nTipo="+this.obsTipo+"&nIdEmpleado="+this.Empleado, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          //console.log(response);

          this.obsMarcacion = response.data.message;
        })




    },
    Horario(item){
    this.NuevoHorario = -1;
    this.ComentarioHorario="";
    this.ModalMediano.isHorarioMarcaciones=true;
    this.ModalMediano.titulo = 'Asignar Horario al Colaborador <br>'+ this.Nombres;
    this.CodigoMarcacion = item.nCodigo;
    this.NuevaHora = item.sHora;
    const fecha = item.sFecha.split('/')
    this.NuevaFecha = fecha[2]+"-"+fecha[1]+"-"+fecha[0];
    let gestion = this.$store.state.menu;
    this.axios
        .get(gestion + "/HorarioPorEmpCombo?nIdEmpleado="+ this.Empleado, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Horarios = response.data.oListaHorarios;
        })
    this.axios
        .get(gestion + "/HorarioPorEmpGrilla?nIdEmpleado="+ this.Empleado, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.ListaHorarios = response.data.oListaHorariosPorEmpleado;
          const countUser = this.ListaHorarios.filter(resp => !resp.disabled);
          this.resultCountHorario = countUser.length;
          this.currentPageHorario = 0;
          if (this.currentPageHorario >= this.totalPagesHorario) {
              this.currentPageHorario = this.totalPagesHorario
            }
          var index = this.currentPageHorario * this.itemsPageDefaultHorario;      
          this.ListaHorariosPaginador = this.ListaHorarios.slice(index,index+this.itemsPageDefaultHorario);
        })


        
    },
    Borrar(item){
    this.ModalPeque.isEliminarMarcaciones=true;
    this.ModalPeque.titulo = 'Eliminar Marcación';
    this.ComentarioMarcacion = item.sComentario;
    this.CodigoMarcacion = item.nCodigo;
    },
    Historial(item){
    this.ModalGrande.isHistorialMarcaciones=true;
    this.ModalGrande.titulo = 'Historial de Marcaciones';
    this.CodigoMarcacion = item.nCodigo;
    let gestion = this.$store.state.menu;
    this.axios
        .get(gestion + "/ListarHistorialMarcacion?nIdMarcacion="+this.CodigoMarcacion, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.HistorialMarcaciones = response.data.oListaMarcaciones;
        })
    },
    EliminarMarcacion(){
    this.load=true;
    let gestion = this.$store.state.menu;
    var opcion = 3;
    var bodyFormData = new FormData();
    bodyFormData.append("nOpcion", opcion);
    bodyFormData.append("nIdMarcacion", this.CodigoMarcacion);
    bodyFormData.append("sFechaHora1", '');
    bodyFormData.append("sFechaHora2", '');
    bodyFormData.append("sComentario", this.ComentarioMarcacion);
    bodyFormData.append("nIdEmpleado", this.Empleado);
    this.axios.post(gestion + "/MarcacionCRUD", bodyFormData, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-Type": "multipart/form-data",
          }
        })
        .then((response) => {
          const data_res = response.data.satisfactorio;
          this.load=false;
            if (data_res == true) { 
            this.ModalPeque.isEliminarMarcaciones=false;
            this.Buscar();
            this.$swal({
              toast: true,
              timer:3000,
              position: 'top',
              showConfirmButton: false,
              title: response.data.message,
              icon: 'success',
              
              });
            }
            else {
            this.$swal({
              toast: true,
              timer:3000,
              position: 'top',
              showConfirmButton: false,
              title: response.data.message,
              icon: 'error',
              
              });  
            }
         
        });
    },
    EditarMarcacion(){
    this.load=true;
    let gestion = this.$store.state.menu;
    var opcion = 2;
    var bodyFormData = new FormData();
    bodyFormData.append("nOpcion", opcion);
    bodyFormData.append("nIdMarcacion", this.CodigoMarcacion);
    bodyFormData.append("sFechaHora1", this.FechaActual+' '+this.HoraActual);
    bodyFormData.append("sFechaHora2", this.FechaMarcacion+' '+this.HoraMarcacion);
    bodyFormData.append("sComentario", this.ComentarioMarcacion);
    bodyFormData.append("nIdEmpleado", this.Empleado);
    this.axios.post(gestion + "/MarcacionCRUD", bodyFormData, {
        headers: {
          Authorization: "Bearer " + localStorage.token,
          "Content-Type": "multipart/form-data",
        }
        })
        .then((response) => {
        const data_res = response.data.satisfactorio;
        this.load=false;
        if (data_res == true) { 
        this.ModalPeque.isEditarMarcaciones=false;
        this.Buscar();
        this.$swal({
          toast: true,
          timer:3000,
          position: 'top',
          showConfirmButton: false,
          title: response.data.message,
          icon: 'success',
          
          });
        }
         
      });
    },
    EditarObservacion(){

      this.load = true;
      let gestion = this.$store.state.menu;

      var bodyFormData = new FormData();

      bodyFormData.append("nIdMarcacion", this.CodigoMarcacion);
      bodyFormData.append("sFecha", this.obsFechaMarcacion);
      bodyFormData.append("nTipo", this.obsTipo);
      bodyFormData.append("nIdEmpleado", this.Empleado);
      bodyFormData.append("sObservacion", this.obsMarcacion);
      this.axios.post(gestion + "/ObservacionMarcRegistrar", bodyFormData, {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              "Content-Type": "multipart/form-data",
            }
          })
          .then((response) => {
            //console.log(response);
            const data_res = response.data.satisfactorio;
            this.load=false;
              if (data_res == true) { 
              this.ModalPeque.isObservacion=false;
              this.$swal({
                toast: true,
                timer:3000,
                position: 'top',
                showConfirmButton: false,
                title: response.data.message,
                icon: 'success',
                
                });
              }
              else {
              this.$swal({
                toast: true,
                timer:3000,
                position: 'top',
                showConfirmButton: false,
                title: response.data.message,
                icon: 'error',
                
                });  
              }
          
          });


    },
    Buscar(){
    let gestion = this.$store.state.menu;
    this.axios
        .get(gestion + "/VerDetalleMarcacion?nIdEmpleado="+this.Empleado+"&sFechaInicio="+this.FechaRegistroInicio+
        "&sFechaFin="+this.FechaRegistroFin+"&nTipoMarc="+this.Marcacion, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.ListaMarcaciones = response.data.oListaMarcaciones;
          
          //console.log(this.ListaMarcaciones);

          const countUser = this.ListaMarcaciones.filter(resp => !resp.disabled);
          this.resultCount = countUser.length;
          this.currentPage = 0;
          if (this.currentPage >= this.totalPages) {
              this.currentPage = this.totalPages
            }
          var index = this.currentPage * this.itemsPageDefault;      
          this.MarcacionesPaginador = this.ListaMarcaciones.slice(index,index+this.itemsPageDefault);
        })

    
    },
    Paginador(obj){
      if (!obj.disabled) {
        return true;
      }
      else {
        return false;
      }
    }, 
    FechainicioUpdate(){
    this.Fechainiciomax = this.FechaRegistroFin;
    },
    FechafinUpdate(){
    this.Fechafinmin = this.FechaRegistroInicio;
    }
    
   
        

  },
}
</script>
<style scoped>
.btn-table{
    margin: 0 5px;

}
</style>
